const inputSG = {
  // PERSONAL INFORMATION
  firstName: '',
  middleName: '',
  lastName: '',
  dateOfBirth: '',

  // IDENTITY DETAILS
  nationalIDNo: '',

  // CURRENT RESIDENTIAL ADDRESS
  block: '',
  streetName: '',
  postCode: '',
  city: '',

  // CONTACT DETAILS
  emailAddress: '',
  phoneNo: '',

  // REFERENCE
  reportingReference: '',
};

export default inputSG;
